import { getApiError } from '@/api/helpers/apiError'

export type PlanErrorKind = 'invalid' | 'unavailable'

export const getPlanErrorKind = (error: unknown): PlanErrorKind | null => {
  if (!error) {
    return null
  }

  return getApiError(error).status === 400 ? 'invalid' : 'unavailable'
}
